import { useRouter } from "next/router";

import CartNumber from "../components/orderProductPanel/cartNumber.comp";
import CategoryBreadcrumbsComp from "../components/orderProductPanel/categoryBreadcrumbs.comp";
import CategoryListComp from "../components/orderProductPanel/categoryList.comp";
import OrderPanelLayout from "../components/orderProductPanel/orderPanelLayout.comp";
import ProductHomeLink from "../components/orderProductPanel/productHomeLink.comp";
import PosCartIcon from "../icons/posicons/cart.icon";

export default function OrderCategoryPage() {
  const { query } = useRouter();

  const parentId = query.catId as string;

  return (
    <OrderPanelLayout>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <ProductHomeLink />
          <CategoryBreadcrumbsComp />
        </div>

        <section className="p-1 bg-surface rounded-full aspect-square relative lg:hidden">
          <PosCartIcon />
          <div className="absolute top-0 -right-1">
            <CartNumber />
          </div>
        </section>
      </div>

      <section className="w-full mt-3  dark:text-white py-6 px-4 dark:bg-her-darkblue2 z-10 space-y-2 shadow-lg">
        <div id="cat-list" className="grid lg:grid-cols-3 md:grid-cols-2 gap-5">
          <CategoryListComp parentId={parentId} />
        </div>
      </section>
    </OrderPanelLayout>
  );
}
